module.exports = __webpack_public_path__ + "img/leighton_b1.f37ec0a0.jpg";